const siteConfig = {
  brandName: "aovabasket",
  companyName: "Hong Kong Zhuojinghong Trading Co., Limited",
  logoText: "aova\nbasket",
  description: "Thoughtfully designed baskets for storage, shopping, picnics and the everyday rituals of home.",
  email: "hub@aovabasket.shop",
  address: "Flat RM A6, Unit 126, 1/F, 143 Wai Yip Street, Kwun Tong, Hong Kong",
  currency: "USD",
  currencySymbol: "$",
};
export default siteConfig;
